module.exports = __webpack_public_path__ + "static/img/cop_sch_logo8.8c3d846b.png";